module.exports = __webpack_public_path__ + "img/2.fac33a6e.jpg";